import styled from '@emotion/styled';
import theme from '@ep/theme';

const FooterLabel = styled.p`
  margin: 0 0 0.625rem;
  font-family: ${theme.typography.boldFont};
  font-size: ${theme.typography.toRem(13)};
  line-height: ${theme.typography.toRem(16)};
  font-weight: bold;
  color: ${theme.colors.white};
  text-transform: uppercase;

  :not(:first-of-type) {
    margin-top: 3rem;
  }
`;

export default FooterLabel;
